import { PrinterOutlined } from '@ant-design/icons';
import { Button, notification } from 'antd';
import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import classes from './PrintWindow.module.scss';

/**
 * 프린트할 요소만 렌더링하기 위해 사용된다.
 */
const PrintWindow: FC<PropsWithChildren<{ onBeforePrint?: () => Promise<unknown> }>> = ({
  children,
  onBeforePrint,
}) => {
  const [printWindowElement, setPrintWindowElement] = useState<HTMLDivElement | null>(null);

  const handleOpenPrintWindow = useCallback(() => {
    // 저장은 기다리지 않는다 — 인쇄가 우선이고, 실패 알림은 onBeforePrint 쪽 책임이다.
    onBeforePrint?.().catch(() => undefined);
    const printWindowElement0 = document.getElementById('print-window');
    if (printWindowElement0 && printWindowElement0 instanceof HTMLDivElement) {
      setPrintWindowElement(printWindowElement0);
      setTimeout(() => {
        window.print();
      }, 300);
      return;
    }
    notification.error({
      message: '인쇄 창을 열 수 없습니다.',
    });
  }, [onBeforePrint]);

  useEffect(() => {
    const handleAfterprintEvent = () => {
      setPrintWindowElement(null);
    };
    window.addEventListener('afterprint', handleAfterprintEvent);
    return () => {
      window.removeEventListener('afterprint', handleAfterprintEvent);
    };
  }, []);

  return (
    <div className={classes.printWindowContainer}>
      <div className={classes.toolbar}>
        <Button
          icon={<PrinterOutlined />}
          onClick={handleOpenPrintWindow}
          type='primary'
          className={classes.printButton}
        />
      </div>
      {children}
      {printWindowElement && createPortal(children, printWindowElement)}
    </div>
  );
};

export default PrintWindow;
